<template>
  <div class="officialNews">
    <div class="officialNewstitle">
      <router-link :to="'/index'"><span>< </span>返回系统首页</router-link>
    </div>
    <div
      class="officialNews_div"
      v-for="(item, index) in textData"
      :key="item.id"
      @click="more(index, $event)"
    >
      <div class="officialNews_title">{{ item.title }}</div>

      <div
      style="color:#999;font-size:14px"
        :style="
          arrIndex.indexOf(index) == -1 ? officialNews_conents.style1 : ''
        "
        v-if="item.context.length > 215"
      >
        {{ item.context }}
      </div>
      <div v-else class="officialNews_conent">{{ item.context }}</div>
      <div v-if="item.context.length > 215">
        <span :class="[{ morder: arrIndex.indexOf(index) == -1 }]">
          <span v-if="arrIndex.indexOf(index) == -1">...阅读更多</span>
        </span>
      </div>
      <div class="officialNews_right">{{ item.create_date }}</div>
    </div>
    <div class="rightPagination">
      <el-pagination
        :total="count"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script >
import * as sysApi from "../../common/sys";
export default {
  data() {
    return {
      arrIndex: [],
      officialNews_conents: {
        style1: {
          display: "-webkit-box",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": "2",
          overflow: "hidden",
          "word-wrap": "break-word",
          "word-break": "break-all",
          "color": "#999999",
          "font-size": "16px",
        },
      },
      textData: [],
      parme: {
        params: {
          page: "1",
          type: 2,
          page_size: "10",
        },
      },
      count: 0,
    };
  },
  created() {
    this.initQuery();
  },
  methods: {
    initQuery() {
      sysApi
        .notice(this.parme)
        .then((res) => {
          console.log(res.result);
          this.count = res.count;
          this.textData = res.result;
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },

    // 点击查看更多
    more(index, e) {
      this.textData.forEach((element, i) => {
        if (index == i) {
          this.arrIndex.push(i);
        }
      });
    },
    handleCurrentChange(val) {
      this.parme.params.page = val;
      this.initQuery();
    },
  },
};
</script>
<style scoped lang="scss">
.officialNews {
  padding: 0 20px 20px 20px;
  //   background: red;
  .officialNewstitle {
    margin-top: 10px;
    text-align: left;
    color: #6692ff;
    font-size: 14px;
    span{
      font-family: "SimSun" !important;
      font-weight: 600;
    }
  }
  .officialNewstitle a:hover {
    color: #759dff;
  }
  .officialNewstitle a:active {
    color: #537fed;
  }
  .officialNews_div {
    background: #fff;
    padding: 20px 20px 30px 20px;
    margin-top: 20px;
    position: relative;
    .officialNews_title {
      color: #333333;
      font-size: 18px;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .officialNews_conent {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;
      color: #999999;
      font-size: 16px;
      position: relative;
      line-height: 27px;
    }
    .morder {
      color: #6692ff;
      font-size: 12px;
      cursor: pointer;
      position: absolute;
      bottom: 30px;
      right: 17px;
      z-index: 99;
      width: 80px;
      height: 20px;
      padding-left: 10px;
      background: #fff;
    }
    .morder:hover{
     color: #759dff; 
    }
    .morder:active{
     color: #537fed; 
    }
    .officialNewsAdd {
      display: none;
    }
    .officialNews_right {
      color: #999;
      float: right;
    }
  }
}
.rightPagination {
  margin-top: 50px;
  float: right;
}
</style>